import { useState } from 'react';
import { topics } from '@/mocks/home';

export default function TopicWall() {
  const [active, setActive] = useState('最新地址');

  return (
    <section id="topics" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 rounded-full bg-accent-500" />
          <span className="font-label text-sm tracking-[0.2em] text-accent-600">TOPIC WALL</span>
        </div>
        <div className="mt-3 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">话题墙 · 按标签找入口</h2>
          <p className="text-sm text-foreground-600">从访问问题到排查方向，点选标签快速定位你想看的入口信息。</p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2.5">
          {topics.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors ${
                active === t
                  ? 'border-accent-500 bg-accent-500 text-background-50'
                  : 'border-background-300 bg-background-100 text-foreground-700 hover:border-accent-300 hover:text-foreground-950'
              }`}
            >
              #{t}
            </button>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-background-100/60 p-5 md:p-6">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div>
              <p className="font-label text-sm tracking-wider text-accent-700">当前筛选标签</p>
              <p className="mt-1 font-heading text-xl text-foreground-950">#{active}</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-100 px-3 py-1.5 text-[13px] text-secondary-900">相关入口 6 条</span>
              <span className="rounded-full bg-primary-100 px-3 py-1.5 text-[13px] text-primary-900">更新短讯 3 条</span>
              <span className="rounded-full bg-background-200 px-3 py-1.5 text-[13px] text-foreground-700">收藏指南 2 篇</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}